// Module
var code = " <md-table-pagination md-limit=\"$ctrl.limit\" md-limit-options=\"$ctrl.limitOptions\" md-page=\"$ctrl.page\" md-total=\"{{$ctrl.getTotal()}}\" md-page-select md-on-paginate=\"$ctrl.onPageChange()\"> </md-table-pagination> ";
// Exports
export default code;